/* eslint-disable */

export enum OfferStatus {
  UNKNOWN_OFFER_STATUS = "UNKNOWN_OFFER_STATUS",
  CREATED_INACTIVE = "CREATED_INACTIVE",
  ACTIVE = "ACTIVE",
  REDEEMED = "REDEEMED",
  EXPIRED = "EXPIRED",
  REVOKED = "REVOKED",
}
